import axios from "@/http";
import { handleGetRequestParams } from '@/common/js/util'

class LocalDistribution {
  /* 市内配送列表 */
  static getLocalDistributionList(options) {
    let url = `/oa/api/city/delivery/import/page?`;
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 录入 */
  static postEntryLocalDistribution(data) {
    let url = `/oa/api/city/delivery/import/save`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 成本设置详情 */
  static getCostSettingDetails(warehouseId) {
    let url = `/oa/api/city/delivery/import/get/cost/setting?warehouseId=${warehouseId}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 成本设置保存 */
  static postSaveCostSetting(data) {
    let url = `/oa/api/city/delivery/import/save/cost/setting`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default LocalDistribution;